"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _classnames = _interopRequireDefault(require("classnames"));
var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.7 5.286a1 1 0 0 1 .014 1.415l-9.527 9.701a1.984 1.984 0 0 1-2.83.01l-3.055-2.98A1 1 0 1 1 5.698 12l3.062 2.986.008.007L18.286 5.3a1 1 0 0 1 1.415-.013z"
  }));
};
CheckIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "button": "EditActions__button__3E8ym",
  "edit-button": "EditActions__edit-button__1k-uG",
  "editButton": "EditActions__edit-button__1k-uG",
  "icon": "EditActions__icon__3YwIl"
}; 
require('../EditActions.css');
var SaveButton = function SaveButton(_ref) {
  var _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    disabled: isDisabled,
    testId: "asset-metadata-save-button-id",
    onClick: onClick,
    "aria-describedby": "asset-metadata-save-button",
    "aria-label": "Save Button",
    className: (0, _classnames.default)(styles.button, styles.editButton),
    size: "md",
    kind: null,
    noFill: true
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon
  }, /*#__PURE__*/_react.default.createElement(CheckIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
    id: "asset-metadata-save-button",
    className: "visually-hidden"
  }, "Save changes in minor version properties"));
};
var _default = exports.default = SaveButton;
//# sourceMappingURL=SaveButton.js.map